module.exports = "mutation setLastVisited($adviceRequestId:String!){setLastVisited(adviceRequestId:$adviceRequestId)}"